import { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import LocaleContext from '../contexts/locale';

export const MENU_TYPE_MAIN = 'main';
export const MENU_TYPE_MISC = 'misc';

const all = [];
const keyMap = {};
const menuMap = {};
const slugMap = {};
const localeMap = {};

export const usePageByKey = (key) => {
	invokeQueryAndMapData();

	const {
		currentLocale
	} = useContext(LocaleContext);

	if (key in keyMap[currentLocale]) {
		return keyMap[currentLocale][key];
	}

	return null;
};

export const usePagesByMenu = (menu) => {
	invokeQueryAndMapData();

	if (menu in menuMap) {
		return filterPagesByLocale(
			menuMap[menu]
		);
	}

	return [];
};

export const usePageBySlug = (slug) => {
	invokeQueryAndMapData();

	if (slug in slugMap) {
		return slugMap[slug];
	}

	return null;
};

export const usePageSlugMap = () => {
	invokeQueryAndMapData();

	return slugMap;
};

const filterPagesByLocale = (pages) => {
	pages = pages || invokeQueryAndMapData();

	const {
		currentLocale
	} = useContext(LocaleContext);

	return pages.filter(
		({ locale }) => locale === currentLocale
	);
};

const invokeQueryAndMapData = () => {
	const {
		allSitePage: {
			edges: pages
		}
	} = useStaticQuery(query);

	const {
		currentLocale
	} = useContext(LocaleContext);

	const mapItem = ({
		node: {
			context			
		}
	}) => context;

	if (all.length === 0) {
		for (let page of pages) {
			let {
				node: {
					context: {
						key,
						slug,
						menu,
						locale
					}
				} 
			} = page;
			
			const item = mapItem(page);

			localeMap[locale] = localeMap[locale] || [];
			keyMap[locale] = keyMap[locale] || {};
			menuMap[menu] = menuMap[menu] || [];

			localeMap[locale].push(item);
			menuMap[menu].push(item);

			keyMap[locale][key] = item;
			slugMap[slug] = item;
			all.push(item);
		}
	}

	return localeMap[currentLocale] || [];
}

export default invokeQueryAndMapData;

const query = graphql`
	query usePagesQuery {
		allSitePage(
			sort: {
				order: ASC
				fields: [context___order]
			}
			filter: {
				context: {
					type: {
						in: [
							"page"
							"offer"
							"service"
							"highlight"
						]
					}
				}
			}
		) {
			edges {
				node {
					context {
						key
						type
						menu
						order						
						slug
						title
						locale
						parent
						description
					}
				}
			}
		}
	}
`;